/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskResultRedacted,
  RiskResultRedacted$inboundSchema,
} from "./riskresultredacted.js";

export type ListRiskResultsForAgentResult = {
  /**
   * Cursor for the next page of results.
   */
  nextCursor?: string | undefined;
  /**
   * The list of risk results with match content redacted to opaque fingerprints.
   */
  results: Array<RiskResultRedacted>;
  /**
   * Total number of findings matching the filters across all non-deleted policies.
   */
  totalCount: number;
};

/** @internal */
export const ListRiskResultsForAgentResult$inboundSchema: z.ZodMiniType<
  ListRiskResultsForAgentResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    results: z.array(RiskResultRedacted$inboundSchema),
    total_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
      "total_count": "totalCount",
    });
  }),
);

export function listRiskResultsForAgentResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskResultsForAgentResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRiskResultsForAgentResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskResultsForAgentResult' from JSON`,
  );
}
